module.exports = __webpack_public_path__ + "img/625.Dirty_floor.92197ac4.svg";